import Typography from "@portal/components/atoms/v2/typography";
import { FormatAccountNumber } from "../../../components/helpers";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { FormatAmount } from "@portal/helpers";
import { ISummaryProps } from "./types";

export const AgreementSummary = ({
  dateTo,
  portfolioId,
  cashAccount,
  header,
  isDefaultLanguage,
  funds,
  startUpAmount = 0,
  startUpAgreement = false,
  oneTime = false,
}: ISummaryProps) => {
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;
  const margin = startUpAgreement ? 20 : 0;

  return (
    <div className="flex flex-col my-3 px-3 py-2 border rounded-lg bg-white w-full" style={{ marginRight: `${margin}px` }}>
      <Typography variant="Lead">{header}</Typography>
      <ul>
        {!oneTime && (
          <li className="flex justify-between">
            <Typography>{texts.PAGE_17_DATE_STOP}</Typography>
            <Typography>{dateTo}</Typography>
          </li>
        )}
        <li className="flex justify-between">
          <Typography>{texts.PAGE_17_PLACEMENT}</Typography>
          <Typography>{portfolioId}</Typography>
        </li>
        <li className="flex justify-between">
          <Typography>{texts.PAGE_17_WITHDRAW}</Typography>
          <Typography>{FormatAccountNumber(cashAccount)}</Typography>
        </li>
        {startUpAgreement && (
          <li className="flex justify-between">
            <Typography> {texts.PAGE_17_AMOUNT_STARTUP}</Typography>
            <Typography>
              {FormatAmount(Math.round(startUpAmount))} {texts.NOK}
            </Typography>
          </li>
        )}
        <li className="flex justify-between mt-3">
          <Typography variant="Bold">{texts.PAGE_17_FUND}</Typography>
          {!startUpAgreement ? <Typography variant="Bold">{texts.PAGE_17_AMOUNT}</Typography> : <div></div>}
        </li>
        {funds.map(fund => {
          return (
            <li className="flex justify-between" key={fund.isin}>
              <Typography key={fund.isin} className="truncate">
                <div className="flex w-[170px]">
                  <p className="truncate">{fund.name}</p>
                </div>
              </Typography>
              <Typography>{`${FormatAmount(Math.round(fund.amount))} ${texts.NOK}`}</Typography>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
